<template>
  <div class="row">
    <!-- Company Info -->
    <div class="col-12">
      <b-card header="Company Info" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row" v-if="!e_company_info">
          <div class="col-12">
            <div class="row">
              <!-- LTD Company Registration Number -->
              <div class="col-lg-3 form-group">
                <label class="form-label" for="ltd_company_reg_number">LTD Registration Number</label>
                <p id="ltd_company_reg_number">
                  <span v-if="company.rel_profile.ltd_reg_number !== null">{{ company.rel_profile.ltd_reg_number }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- LTD Incorporation Date -->
              <div class="col-lg-3 form-group">
                <label class="form-label" for="ltd_incorporation_date">LTD Incorporation Date</label>
                <p id="ltd_incorporation_date">
                  <span v-if="company.rel_profile.ltd_incorporation_date !== null">{{ company.rel_profile.ltd_incorporation_date | formatDate }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Company UTR Number -->
              <div class="col-lg-3 form-group">
                <label class="form-label" for="company_utr_number">Company UTR Number</label>
                <p id="company_utr_number">
                  <span v-if="company.rel_profile.utr_number !== null">{{ company.rel_profile.utr_number }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- UTR Status -->
              <div class="col-lg-3 form-group">
                <label class="form-label" for="utr_status">UTR Status</label>
                <p id="utr_status">
                  <span v-if="company.rel_profile.utr_status !== null">{{ company.rel_profile.utr_status }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
            <div class="row">
              <!-- UK VAT Registered -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="uk_vat_registered">UK VAT Registered</label>
                <p id="uk_vat_registered">
                  <span v-if="company.rel_profile.vat_registered">Yes</span>
                  <span v-else-if="!company.rel_profile.vat_registered">No</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- VAT Number -->
              <div class="col-lg-6 form-group" v-if="company.rel_profile.vat_registered">
                <label class="form-label" for="vat_number">VAT Number</label>
                <p id="vat_number">
                  <span v-if="company.rel_profile.vat_number !== null">{{ company.rel_profile.vat_number }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
            <div class="row">
              <!-- Fall within Off-Payroll / Qualify for Accounts Audit -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="off_payroll_accounts_audit">Fall within Off-Payroll / Qualify for Accounts Audit</label>
                <p id="off_payroll_accounts_audit">
                  <span v-if="company.rel_profile.inside_off_payroll">Yes</span>
                  <span v-else-if="!company.rel_profile.inside_off_payroll">No</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Main Operating Sector -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="operating_sector">Main Operating Sector</label>
                <p id="operating_sector">
                  <span v-if="company.rel_profile.main_operating_sector !== null">{{ company.rel_profile.main_operating_sector }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Domestic/Commercial Operations -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="main_area_operation">Domestic/Commercial Operations</label>
                <p id="main_area_operation">
                  <span v-if="company.rel_profile.domestic_commercial !== null">{{ company.rel_profile.domestic_commercial }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr>
          </div>

          <!-- Signed up to CITB -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="signed_up_to_citb">Signed up to CITB</label>
            <p id="signed_up_to_citb">
              <span v-if="company.rel_profile.signed_up_to_citb">Yes</span>
              <span v-else-if="!company.rel_profile.signed_up_to_citb">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Pass CITB charge on to Contractors -->
          <div class="col-lg-4 form-group" v-if="company.rel_profile.signed_up_to_citb">
            <label class="form-label" for="pass_citb_charge_on_to_contractor">Pass CITB charge on to Contractors</label>
            <p id="pass_citb_charge_on_to_contractor">
              <span v-if="company.rel_profile.pass_citb_charge_to_contractors">Yes</span>
              <span v-else-if="!company.rel_profile.pass_citb_charge_to_contractors">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>

          <div class="col-12">
            <hr>
          </div>

          <div class="col-12">
            <h5 class="font-weight-bold">Accountant</h5>
          </div>
          <!-- Currently use an Accountant -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="currently_use_accountant">Currently use an Accountant</label>
            <p id="currently_use_accountant">
              <span v-if="company.rel_profile.use_accountant">Yes</span>
              <span v-else-if="!company.rel_profile.use_accountant">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <div class="col-12" v-if="company.rel_profile.use_accountant">
            <div class="row">
              <!-- Accountant Company Name -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="accountant_company_name">Accountant Company Name</label>
                <p id="accountant_company_name">
                  <span v-if="company.rel_profile.accountant_company_name !== null">{{ company.rel_profile.accountant_company_name }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Accountant Contact Number -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="accountant_contact_number">Accountant Contact Number</label>
                <p id="accountant_contact_number">
                  <span v-if="company.rel_profile.accountant_contact_number !== null">{{ company.rel_profile.accountant_contact_number }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Contractor HR advice from Accountants -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="contractor_hr_advice_from_accountants">Contractor HR advice from Accountants</label>
                <p id="contractor_hr_advice_from_accountants">
                  <span v-if="company.rel_profile.accountant_hr_advice">Yes</span>
                  <span v-else-if="!company.rel_profile.accountant_hr_advice">No</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr>
          </div>

          <div class="col-12">
            <h5 class="font-weight-bold">Employment Law/HR</h5>
          </div>
          <!-- Outsource Employment Law/HR -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="outsource_employment_law_hr">Outsource Employment Law/HR</label>
            <p id="outsource_employment_law_hr">
              <span v-if="company.rel_profile.employment_law_hr">Yes</span>
              <span v-else-if="!company.rel_profile.employment_law_hr">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <div class="col-12" v-if="company.rel_profile.employment_law_hr">
            <div class="row">
              <!-- Outsourced Employment Law/HR Yearly Spend -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="outsourced_employment_law_hr_yearly_spend">Yearly Spend</label>
                <p id="outsourced_employment_law_hr_yearly_spend">
                  <span v-if="company.rel_profile.employment_law_hr_yearly_spend !== null">{{ company.rel_profile.employment_law_hr_yearly_spend }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employment Law/HR Company Name -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="outsourced_employment_law_hr_company_name">Company Name</label>
                <p id="outsourced_employment_law_hr_company_name">
                  <span v-if="company.rel_profile.employment_law_hr_company_name !== null">{{ company.rel_profile.employment_law_hr_company_name }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Employment Law/HR Contact Number -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="outsourced_employment_law_hr_contact_number">Contact Number</label>
                <p id="outsourced_employment_law_hr_contact_number">
                  <span v-if="company.rel_profile.employment_law_hr_contact_number !== null">{{ company.rel_profile.employment_law_hr_contact_number }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <!-- Current IR35 Strategy -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="current_ir35_strategy">Current IR35 Strategy</label>
                <p id="current_ir35_strategy">
                  <span v-if="company.rel_profile.employment_law_hr_ir35_strategy !== null">{{ company.rel_profile.employment_law_hr_ir35_strategy }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Current Off-Payroll Strategy -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="current_off_payroll_strategy">Current Off-Payroll Strategy</label>
                <p id="current_off_payroll_strategy">
                  <span v-if="company.rel_profile.employment_law_hr_off_payroll_strategy !== null">{{ company.rel_profile.employment_law_hr_off_payroll_strategy }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-4 offset-md-8">
            <button @click.prevent="show_edit_company_info" class="btn orcaBtn blueBtn sm_btn float-right">Edit Company Info</button>
          </div>
        </div>
        <div class="row" v-if="e_company_info">
          <div class="col-12">
            <ValidationObserver ref="updateCompanyInfo" slim>
              <form role="form" @submit.prevent="update_company_info" class="row">
                <!-- EDIT - LTD Incorporation Date -->
                <div class="col-lg-4 form-group">
                  <label class="form-label" for="uci_ltd_incorporation_date">Incorporation Date</label>
                  <datepicker v-model="uci.ltd_incorporation_date" id="uci_ltd_incorporation_date" name="uci_ltd_incorporation_date" :input-class="'date-input'"
                              :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_ltd_incorporation_date" :use-utc="true"></datepicker>
                </div>
                <!-- Edit - Company UTR Number -->
                <ValidationProvider rules="digits:10" v-slot="{errors, classes}" name="Company UTR Number" tag="div" class="col-lg-4 form-group">
                  <label class="form-label" for="uci_utr_number">Company UTR Number</label>
                  <input type="search" v-model="uci.utr_number" id="uci_utr_number" name="uci_utr_number" class="form-input" :class="classes" maxlength="10">
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- UTR Status -->
                <div class="col-lg-4 form-group">
                  <label class="form-label" for="uci_utr_status">UTR Status</label>
                  <multiselect v-model="uci.utr_status" id="uci_utr_status" name="uci_utr_status" placeholder="" :options="ms_opts.uci_utr_status"
                               label="value" selectLabel=""></multiselect>
                </div>
                <!-- UK VAT Registered -->
                <div class="col-12">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_uk_vat_registered">UK VAT Registered</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.vat_registered" id="uci_uk_vat_registered" name="uci_uk_vat_registered" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <!-- VAT Number -->
                <ValidationProvider rules="VATregNoValidate|max:9" v-slot="{errors, classes}" name="VAT Number" tag="div" class="col-lg-4 offset-lg-8 form-group"
                                    v-if="uci.vat_registered">
                  <label class="form-label" for="uci_vat_number">VAT Number</label>
                  <div class="input-group">
                    <div class="input-group-prepend"><span class="input-group-text">GB</span></div>
                    <input type="search" v-model="uci.vat_number" id="uci_vat_number" name="uci_vat_number" class="form-input" :class="classes" maxlength="9">
                  </div>
                  <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                </ValidationProvider>
                <!-- Fall within Off-Payroll / Qualify for Accounts Audit -->
                <div class="col-12">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_inside_off_payroll">Fall within Off-Payroll / Qualify for Accounts
                      Audit</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.inside_off_payroll" id="uci_inside_off_payroll" name="uci_inside_off_payroll" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <!-- Main Operating Sector -->
                <div class="col-lg-4 form-group">
                  <label class="form-label" for="uci_operating_sector">Main Operating Sector</label>
                  <input type="search" v-model="uci.main_operating_sector" id="uci_operating_sector" name="uci_operating_sector" class="form-input">
                </div>
                <!-- Domestic/Commercial Operations -->
                <div class="col-lg-4 form-group">
                  <label class="form-label" for="uci_domestic_commercial">Domestic/Commercial Operations</label>
                  <multiselect v-model="uci.domestic_commercial" id="uci_domestic_commercial" name="uci_domestic_commercial" placeholder=""
                               :options="ms_opts.uci_domestic_commercial"
                               selectLabel=""></multiselect>
                </div>
                <!-- Signed up to CITB -->
                <div class="col-12">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_signed_up_to_citb">Signed up to CITB</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.signed_up_to_citb" id="uci_signed_up_to_citb" name="uci_signed_up_to_citb" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <!-- Pass CITB charge on to Contractors -->
                <div class="col-12" v-if="uci.signed_up_to_citb">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_pass_citb_charge_to_contractors">Pass CITB charge on to
                      Contractors</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.pass_citb_charge_to_contractors" id="uci_pass_citb_charge_to_contractors" name="uci_pass_citb_charge_to_contractors"
                                        :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="font-weight-bold">Accountant</h5>
                </div>

                <!-- Currently use an Accountant -->
                <div class="col-12">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_currently_use_accountant">Currently use an Accountant</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.use_accountant" id="uci_currently_use_accountant" name="uci_currently_use_accountant" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="uci.use_accountant">
                  <div class="row">
                    <div class="col-lg-4"></div>
                    <!-- Accountant Company Name -->
                    <div class="col-lg-4 form-group">
                      <label class="form-label" for="uci_accountant_company_name">Accountant Company Name</label>
                      <input type="search" v-model="uci.accountant_company_name" id="uci_accountant_company_name" name="uci_accountant_company_name" class="form-input">
                    </div>
                    <!-- Accountant Contact Number -->
                    <ValidationProvider rules="numeric|max:15" v-slot="{errors, classes}" name="Accountant Contact Number" tag="div" class="col-lg-4 form-group">
                      <label class="form-label" for="uci_accountant_contact_number">Accountant Contact Number</label>
                      <input type="search" v-model="uci.accountant_contact_number" id="uci_accountant_contact_number" name="uci_accountant_contact_number" class="form-input"
                             :class="classes" maxlength="15">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Contractor HR advice from Accountants -->
                    <div class="col-12">
                      <div class="row">
                        <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_accountant_hr_advice">Contractor HR advice from Accountants</label>
                        <div class="col-lg-4 form-group">
                          <bootstrap-toggle v-model="uci.accountant_hr_advice" id="uci_accountant_hr_advice" name="uci_accountant_hr_advice" :options="{ on: 'Yes', off: 'No' }"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <hr>
                </div>
                <div class="col-12">
                  <h5 class="font-weight-bold">Employment Law/HR</h5>
                </div>
                <!-- Outsource Employment Law/HR -->
                <div class="col-12">
                  <div class="row">
                    <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="uci_employment_law_hr">Outsource Employment Law/HR</label>
                    <div class="col-lg-4 form-group">
                      <bootstrap-toggle v-model="uci.employment_law_hr" id="uci_employment_law_hr" name="uci_employment_law_hr" :options="{ on: 'Yes', off: 'No' }"/>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-if="uci.employment_law_hr">
                  <div class="row">
                    <!-- Outsourced Employment Law/HR Yearly Spend -->
                    <div class="col-lg-4 form-group">
                      <label class="form-label" for="uci_outsourced_employment_law_hr_yearly_spend">Yearly Spend</label>
                      <input type="search" v-model="uci.employment_law_hr_yearly_spend" id="uci_outsourced_employment_law_hr_yearly_spend"
                             name="uci_outsourced_employment_law_hr_yearly_spend" class="form-input">
                    </div>
                    <!-- Employment Law/HR Company Name -->
                    <div class="col-lg-4 form-group">
                      <label class="form-label" for="uci_employment_law_hr_company_name">Company Name</label>
                      <input type="search" v-model="uci.employment_law_hr_company_name" id="uci_employment_law_hr_company_name"
                             name="uci_employment_law_hr_company_name" class="form-input">
                    </div>
                    <!-- Employment Law/HR Contact Number -->
                    <ValidationProvider rules="numeric|max:15" v-slot="{errors, classes}" name="Employment Law/HR Contact Number" tag="div" class="col-lg-4 form-group">
                      <label class="form-label" for="uci_outsourced_employment_law_hr_contact_number">Contact Number</label>
                      <input type="search" v-model="uci.employment_law_hr_contact_number" id="uci_outsourced_employment_law_hr_contact_number"
                             name="uci_outsourced_employment_law_hr_contact_number" class="form-input" :class="classes" maxlength="15">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
                <!-- Current IR35 Strategy -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="uci_employment_law_hr_ir35_strategy">Current IR35 Strategy</label>
                  <textarea type="search" v-model="uci.employment_law_hr_ir35_strategy" id="uci_employment_law_hr_ir35_strategy"
                            name="uci_employment_law_hr_ir35_strategy" class="form-input" rows="3"></textarea>
                </div>
                <!-- Current Off-Payroll Strategy -->
                <div class="col-lg-6 form-group">
                  <label class="form-label" for="uci_employment_law_hr_off_payroll_strategy">Current Off-Payroll Strategy</label>
                  <textarea type="search" v-model="uci.employment_law_hr_off_payroll_strategy" id="uci_employment_law_hr_off_payroll_strategy"
                            name="uci_employment_law_hr_off_payroll_strategy" class="form-input" rows="3"></textarea>
                </div>

                <!-- Buttons -->
                <div class="col-12">
                  <div class="row">
                    <div class="12">
                      <hr>
                    </div>
                    <div class="col-6">
                      <button v-if="!saving_company_info"
                              @click.prevent="cancel_edit_company_info" class="btn orcaBtn sm_btn w-100 grey_bg">Cancel
                      </button>
                    </div>
                    <div class="col-6">
                      <button type="submit" class="btn orcaBtn sm_btn w-100" :disabled="saving_company_info">
                        <span v-if="saving_company_info" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Updating ...</span>
                        <span v-else>Update Company Info</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>
    <!-- Current Staff/Contractor Information -->
    <div class="col-12">
      <b-card header="Current Staff/Contractor Information" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row" v-if="!e_staff_contractor_info">
          <div class="col-12">
            <h5 class="font-weight-bold">Staff/Contractor Engagement</h5>
          </div>
          <!-- Number of Limited Companies -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="number_of_ltd_companies_engaged">Number of Limited Companies</label>
            <p id="number_of_ltd_companies_engaged">
              <span v-if="company.rel_profile.num_ltd_companies_engaged !== null">{{ company.rel_profile.num_ltd_companies_engaged }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Number of PSC's -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="number_of_pscs_engaged"> Number of PSC's</label>
            <p id="number_of_pscs_engaged">
              <span v-if="company.rel_profile.num_pscs_engaged !== null">{{ company.rel_profile.num_pscs_engaged }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Number of Labour only Sub-Contractors (CIS) -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="number_of_sub_contractors_engaged">Number of Labour only Sub-Contractors (CIS)</label>
            <p id="number_of_sub_contractors_engaged">
              <span v-if="company.rel_profile.num_cis_sub_contractors_engaged !== null">{{ company.rel_profile.num_cis_sub_contractors_engaged }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <!-- Number of PAYE -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="number_of_paye_engaged">Number of PAYE</label>
            <p id="number_of_paye_engaged">
              <span v-if="company.rel_profile.num_paye_engaged !== null">{{ company.rel_profile.num_paye_engaged }}</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>

          <div class="col-12">
            <hr>
          </div>

          <div class="col-12">
            <h5 class="font-weight-bold">Current Payroll Company</h5>
          </div>
          <!-- Currently use Payroll Company -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="currently_use_payroll_company">Currently use Payroll Company</label>
            <p id="currently_use_payroll_company">
              <span v-if="company.rel_profile.use_payroll_company">Yes</span>
              <span v-else-if="!company.rel_profile.use_payroll_company">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <div class="col-12" v-if="company.rel_profile.use_payroll_company">
            <div class="row">
              <!-- Payroll Company Name -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="payroll_company_name">Company Name</label>
                <p id="payroll_company_name">
                  <span v-if="company.rel_profile.payroll_company_name !== null">{{ company.rel_profile.payroll_company_name }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Payroll Charge Type Per Worker -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="payroll_company_charge_type">Charge Type Per Worker</label>
                <p id="payroll_company_charge_type">
                  <span v-if="company.rel_profile.payroll_company_charge_type !== null">{{ company.rel_profile.payroll_company_charge_type }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Payroll Charge Amount -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="payroll_company_charge_amount">Charge Amount</label>
                <p id="payroll_company_charge_amount">
                     <span v-if="company.rel_profile.payroll_company_charge_type === '£ (Pound)'">
                       {{ company.rel_profile.payroll_company_charge_amount | currency }}
                     </span>
                     <span v-else-if="company.rel_profile.payroll_company_charge_type === '% (Percentage)'">
                       {{ company.rel_profile.payroll_company_charge_amount | percentage }}
                     </span>
                     <span v-else>
                         {{ company.rel_profile.payroll_company_charge_amount }}
                     </span>
                </p>
              </div>
              <!-- Perform Intermediary Reporting -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="payroll_company_perform_intermediary_reps">Perform Intermediary Reporting (Details)</label>
                <p id="payroll_company_perform_intermediary_reps">
                  <span v-if="company.rel_profile.payroll_company_perform_intermediary_reps !== null">{{ company.rel_profile.payroll_company_perform_intermediary_reps }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Payroll Terms of Service -->
              <div class="col-lg-8 form-group">
                <label class="form-label" for="payroll_company_additional_information">Terms of Business Additional Information</label>
                <p id="payroll_company_additional_information">
                  <span v-if="company.rel_profile.payroll_company_additional_information !== null">{{ company.rel_profile.payroll_company_additional_information }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Recruitment</h5>
          </div>
          <!-- Currently use Recruitment Agencies -->
          <div class="col-lg-4 form-group">
            <label class="form-label" for="use_recruitment_agencies">Currently use Recruitment Agencies</label>
            <p id="use_recruitment_agencies">
              <span v-if="company.rel_profile.use_recruitment_agencies">Yes</span>
              <span v-else-if="!company.rel_profile.use_recruitment_agencies">No</span>
              <span v-else>&nbsp;</span>
            </p>
          </div>
          <div class="col-12" v-if="company.rel_profile.use_recruitment_agencies">
            <div class="row">
              <!-- Approx weekly numbers -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="recruitment_approx_weekly_numbers">Approx weekly numbers</label>
                <p id="recruitment_approx_weekly_numbers">
                  <span v-if="company.rel_profile.recruitment_agencies_weekly_num !== null">{{ company.rel_profile.recruitment_agencies_weekly_num }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
              <!-- Recruitment Payroll Companies -->
              <div class="col-lg-8 form-group">
                <label class="form-label" for="recruitment_payroll_companies">Recruitment Agency Payroll Companies & how Operate</label>
                <p id="recruitment_payroll_companies">
                  <span v-if="company.rel_profile.recruitment_agencies_payroll_how_operate !== null">{{ company.rel_profile.recruitment_agencies_payroll_how_operate }}</span>
                  <span v-else>&nbsp;</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-4 offset-md-8">
            <button @click.prevent="show_edit_staff_contractor_info" class="btn orcaBtn blueBtn sm_btn float-right">Edit Staff/Contractor Info</button>
          </div>
        </div>
        <div class="row" v-if="e_staff_contractor_info">
          <!-- Number of Limited Companies -->
          <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Number of Limited Companies" tag="div" class="col-lg-4 form-group">
            <label class="form-label" for="usci_number_of_ltd_companies_engaged">Number of Limited Companies</label>
            <input type="search" v-model="usci.num_ltd_companies_engaged" id="usci_number_of_ltd_companies_engaged" name="usci_number_of_ltd_companies_engaged" class="form-input"
                   :class="classes" maxlength="10">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Number of PSC's -->
          <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Number of PSC's" tag="div" class="col-lg-4 form-group">
            <label class="form-label" for="usci_number_of_ltd_companies_engaged">Number of PSC's</label>
            <input type="search" v-model="usci.num_pscs_engaged" id="usci_number_of_pscs_engaged" name="usci_number_of_pscs_engaged" class="form-input"
                   :class="classes" maxlength="10">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Number of Labour only Sub-Contractors (CIS) -->
          <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Number of Labour only Sub-Contractors" tag="div" class="col-lg-4 form-group">
            <label class="form-label" for="usci_number_of_sub_contractors_engaged">Number of Labour only Sub-Contractors</label>
            <input type="search" v-model="usci.num_cis_sub_contractors_engaged" id="usci_number_of_sub_contractors_engaged" name="usci_number_of_sub_contractors_engaged"
                   class="form-input" :class="classes" maxlength="10">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
          <!-- Number of PAYE -->
          <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Number of PAYE" tag="div" class="col-lg-4 form-group">
            <label class="form-label" for="usci_number_of_paye_engaged">Number of PAYE</label>
            <input type="search" v-model="usci.num_paye_engaged" id="usci_number_of_paye_engaged" name="usci_number_of_paye_engaged"
                   class="form-input" :class="classes" maxlength="10">
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>

          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Current Payroll Company</h5>
          </div>
          <!-- Currently use Payroll Company -->
          <div class="col-12">
            <div class="row">
              <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="usci_currently_use_payroll_company">Currently use Payroll Company</label>
              <div class="col-lg-4 form-group">
                <bootstrap-toggle v-model="usci.use_payroll_company" id="usci_currently_use_payroll_company" name="usci_currently_use_payroll_company"
                                  :options="{ on: 'Yes', off: 'No' }"/>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="usci.use_payroll_company">
            <div class="row">
              <!-- Payroll Company Name -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="usci_payroll_company_name">Payroll Company Name</label>
                <input type="search" v-model="usci.payroll_company_name" id="usci_payroll_company_name" name="usci_payroll_company_name" class="form-input">
              </div>
              <!-- Payroll Charge Type Per Worker -->
              <div class="col-lg-4 form-group">
                <label class="form-label" for="usci_payroll_company_charge_type">Charge Type Per Worker</label>
                <multiselect v-model="usci.payroll_company_charge_type" id="usci_payroll_company_charge_type" name="usci_payroll_company_charge_type" placeholder=""
                             :options="ms_opts.usci_payroll_charge_type" label="value" selectLabel=""></multiselect>
              </div>
              <!-- Payroll Charge Amount -->
              <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Payroll Charge Amount" tag="div" class="col-lg-4 form-group">
                <label class="form-label" for="usci_payroll_company_charge_amount">Payroll Charge Amount</label>
                <div class="input-group">
                  <div v-if="usci.payroll_company_charge_type !== null && usci.payroll_company_charge_type.value === '£ (Pound)'" class="input-group-prepend">
                    <span class="input-group-text">&pound;</span>
                  </div>
                  <div v-else-if="usci.payroll_company_charge_type !== null && usci.payroll_company_charge_type.value === '% (Percentage)'" class="input-group-prepend">
                    <span class="input-group-text">&percnt;</span>
                  </div>

                <input type="search" v-model="usci.payroll_company_charge_amount" id="usci_payroll_company_charge_amount" name="usci_payroll_company_charge_amount"
                       class="form-input" :class="[classes, usci.payroll_company_charge_type !== null ? '' : 'disabled']" maxlength="10"
                       :disabled="usci.payroll_company_charge_type === null">
                </div>
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Perform Intermediary Reporting (Details) -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="usci_payroll_company_perform_intermediary_reps">Perform Intermediary Reporting (Details)</label>
                <textarea type="search" v-model="usci.payroll_company_perform_intermediary_reps" id="usci_payroll_company_perform_intermediary_reps"
                          name="usci_payroll_company_perform_intermediary_reps" class="form-input" rows="3"></textarea>
              </div>
              <!-- Payroll Terms of Service -->
              <div class="col-lg-6 form-group">
                <label class="form-label" for="usci_payroll_company_additional_information">Terms of Business Additional Information</label>
                <textarea type="search" v-model="usci.payroll_company_additional_information" id="usci_payroll_company_additional_information"
                          name="usci_payroll_company_additional_information" class="form-input" rows="3"></textarea>
              </div>
            </div>
          </div>

          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <h5 class="font-weight-bold">Recruitment</h5>
          </div>
          <!-- Currently use Recruitment Agencies -->
          <div class="col-12">
            <div class="row">
              <label class="col-lg-8 cardLabel font-weight-bold" style="font-size: 0.7rem;" for="usci_use_recruitment_agencies">Currently use Recruitment Agencies</label>
              <div class="col-lg-4 form-group">
                <bootstrap-toggle v-model="usci.use_recruitment_agencies" id="usci_use_recruitment_agencies" name="usci_use_recruitment_agencies"
                                  :options="{ on: 'Yes', off: 'No' }"/>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="usci.use_recruitment_agencies">
            <div class="row">
              <!-- Approx weekly numbers -->
              <ValidationProvider rules="numeric" v-slot="{errors, classes}" name="Approx weekly numbers" tag="div" class="col-lg-4 form-group">
                <label class="form-label" for="usci_recruitment_approx_weekly_numbers">Approx weekly numbers</label>
                <input type="search" v-model="usci.recruitment_agencies_weekly_num" id="usci_recruitment_approx_weekly_numbers" name="usci_recruitment_approx_weekly_numbers"
                       class="form-input" :class="classes" maxlength="10">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
              <!-- Recruitment Payroll Companies -->
              <div class="col-lg-8 form-group">
                <label class="form-label" for="usci_recruitment_payroll_companies">Recruitment Agency Payroll Companies & how Operate</label>
                <textarea type="search" v-model="usci.recruitment_agencies_payroll_how_operate" id="usci_recruitment_payroll_companies"
                          name="usci_recruitment_payroll_companies" class="form-input" rows="3"></textarea>
              </div>
            </div>
          </div>

          <div class="col-12">
            <ValidationObserver ref="updateStaffContractorInfo" slim>
              <form role="form" @submit.prevent="update_staff_contractor_info" class="row">
                <!-- Buttons -->
                <div class="col-12">
                  <div class="row">
                    <div class="12">
                      <hr>
                    </div>
                    <div class="col-6">
                      <button v-if="!saving_staff_contractor_info"
                              @click.prevent="cancel_edit_staff_contractor_info" class="btn orcaBtn sm_btn w-100 grey_bg">Cancel
                      </button>
                    </div>
                    <div class="col-6">
                      <button type="submit" class="btn orcaBtn sm_btn w-100" :disabled="saving_staff_contractor_info">
                        <span v-if="saving_staff_contractor_info" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Updating ...</span>
                        <span v-else>Update Staff/Contractor Info</span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from "vue-multiselect";
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "company_info",
  props: ['company'],
  components: {
    Datepicker,
    Multiselect,
    BootstrapToggle,
  },
  data() {
    return {
      ms_opts: {
        uci_utr_status: this.$store.state.crm_options.utr_status,
        uci_domestic_commercial: ['Domestic', 'Commercial'],
        usci_payroll_charge_type: this.$store.state.crm_options.fee_type
      },

      e_company_info: false,
      uci: {},
      saving_company_info: false,

      e_staff_contractor_info: false,
      usci: {},
      saving_staff_contractor_info: false,
    }
  },
  beforeMount() {
    // set uci (update company info) -> non-reactive
    this.uci = Object.assign({}, this.company.rel_profile)
    // set usci (update company info) -> non-reactive
    this.usci = Object.assign({}, this.company.rel_profile)
  },
  methods: {
    /**
     * ALL FORMS
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    /* Date Format for datepicker */
    dateFormat(date) {
      return this.$moment.utc(date).format("DD/MM/YYYY");
    },
    /**
     * Company Info
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    show_edit_company_info() {
      this.uci = Object.assign({}, this.company.rel_profile)
      if (this.company.rel_profile.utr_status !== null) {
        this.uci.utr_status = this.ms_opts.uci_utr_status.find(f => f.value === this.company.rel_profile.utr_status)
      }
      this.$nextTick(() => this.e_company_info = true)
    },
    cancel_edit_company_info() {
      this.e_company_info = false;
      this.uci = {};
    },
    // Form Actions
    select_ltd_incorporation_date(date) {
      if (date !== null) {
        this.uci.ltd_incorporation_date = this.$moment.utc(date).format('YYYY-MM-DD');
      }
    },
    update_company_info() {
      this.$refs.updateCompanyInfo.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updateCompanyInfo);
        }
        else {
          this.saving_company_info = true;

          if (this.uci.utr_status !== null) {
            this.uci.utr_status = this.uci.utr_status.value;
          }

          this.uci.log_by_type = 'App\\Models\\Users\\User';
          this.uci.log_by_id = this.$store.state.auth.me.id;

          axios.patch(this.crmApiPath + 'company/profile/' + this.uci.id, this.uci).then(() => {
            this.e_company_info = false;
            this.saving_company_info = false;
            this.uci = {};
            this.$bus.$emit('company::reload', {action: true});
          })
        }
      });
    },
    /**
     * Staff/Contractor Info
     * ------------------------------------------------------------------------------------------------------------------------------------
     */
    show_edit_staff_contractor_info() {
      this.usci = Object.assign({}, this.company.rel_profile)
      if (this.company.rel_profile.payroll_company_charge_type !== null) {
        this.usci.payroll_company_charge_type = this.ms_opts.usci_payroll_charge_type.find(f => f.value === this.company.rel_profile.payroll_company_charge_type)
      }
      this.$nextTick(() => this.e_staff_contractor_info = true)
    },
    cancel_edit_staff_contractor_info() {
      this.e_staff_contractor_info = false;
      this.usci = {};
    },
    // Form Actions
    update_staff_contractor_info() {
      this.$refs.updateStaffContractorInfo.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.updateStaffContractorInfo);
        }
        else {
          this.saving_staff_contractor_info = true;

          if (this.usci.payroll_company_charge_type !== null) {
            this.usci.payroll_company_charge_type = this.usci.payroll_company_charge_type.value;
          }

          this.usci.log_by_type = 'App\\Models\\Users\\User';
          this.usci.log_by_id = this.$store.state.auth.me.id;

          axios.patch(this.crmApiPath + 'company/profile/' + this.usci.id, this.usci).then(() => {
            this.e_staff_contractor_info = false;
            this.saving_staff_contractor_info = false;
            this.usci = {};
            this.$bus.$emit('company::reload', {action: true});
          })
        }
      })
    }
  },
  watch: {
    'uci.vat_registered'(val) {
      if (!val) {
        this.uci.vat_number = '';
      }
    },
    'uci.signed_up_to_citb'(val) {
      if (!val) {
        this.uci.pass_citb_charge_to_contractors = false;
      }
    },
    'uci.use_accountant'(val) {
      if (!val) {
        this.uci.accountant_company_name = '';
        this.uci.accountant_contact_number = '';
        this.uci.accountant_hr_advice = false;
      }
    },
    'uci.employment_law_hr'(val) {
      if (!val) {
        this.uci.employment_law_hr_yearly_spend = '';
        this.uci.employment_law_hr_company_name = '';
        this.uci.employment_law_hr_contact_number = '';
      }
    }
  }
}
</script>
